import useSubfolderLanguageAndLocale from 'bundles/internationalization-lib/hooks/useSubfolderLanguageAndLocale';
import useEnableSubfolderLinksForXDP from 'bundles/unified-description-page-common/hooks/useEnableSubfolderLinksForXDP';

/**
 * Hook that determines the appropriate subfolder prefix path for XDP (Extensible Description page) links.
 * It checks whether subfolder links are enabled for XDP and whether there is a specific subfolder language and locale code available.
 * If both are true, it returns the subfolder language and locale code, otherwise, it returns an empty string.
 *
 * @returns {string} The subfolder prefix path based on current configuration and language/locale settings, or an empty string.
 */
const useXdpSubfolderPrefixPath = () => {
  const isXdpSubfolderEnabled = useEnableSubfolderLinksForXDP();
  const subfolderLanguageAndLocaleCode = useSubfolderLanguageAndLocale();

  const xdpSubfolderPrefixPath =
    isXdpSubfolderEnabled && subfolderLanguageAndLocaleCode ? subfolderLanguageAndLocaleCode : '';

  return xdpSubfolderPrefixPath;
};

export default useXdpSubfolderPrefixPath;
